export default __webpack_public_path__ + "static/media/potion1.10d484a2.png";